import angular from 'angular';
import gridHeight from '../core/shared-service/grid-utils';

class KissInvoiceGridController {
    /*@ngInject*/
    constructor(UtilSvc, $scope, INVOICE, uiGridConstants) {
        this.UtilSvc = UtilSvc;
        this.$scope = $scope;
        this.INVOICE = INVOICE;
        this.uiGridConstants = uiGridConstants;
    }

    $onInit() {
        let vm = this;
        vm.getGridHeight = getGridHeight;
        vm.gridOptions = {
            columnDefs: vm.INVOICE.columnDefs,
            exporterOlderExcelCompatibility: true,
            useExternalPagination: true,
            onRegisterApi: onRegisterApi,
            enableSorting: false,
            enableGridMenu: false,
            enableColumnMenus: false,
            enableVerticalScrollbar: vm.uiGridConstants.scrollbars.NEVER,
            paginationPageSizes: vm.gridParams.paginationPageSizes,
            paginationPageSize: vm.gridParams.paginationPageSize
        };

        // Grille
        function onRegisterApi(gridApi) {
            vm.gridApi = gridApi;

            // Sorting & pagination
            gridApi.pagination.on.paginationChanged(vm.$scope, paginationChanged);
        }

        function paginationChanged(page, size) {
            vm.gridParams.paginationPageSize = size;
            vm.gridParams.page = page - 1;
            vm.searchFunction();
        }

        function getGridHeight() {
            return gridHeight(vm.gridApi);
        }
    }

    $onChanges(changesObj) {
        if (changesObj.data && changesObj.data.currentValue.invoices) {
            this.gridOptions.data = changesObj.data.currentValue.invoices;
            this.gridOptions.totalItems = changesObj.data.currentValue.totalElements;
        }
    }
}

angular.module('app.docrepo_invoice').component('docrepoInvoiceGrid', {
    templateUrl: require('./grid.html'),
    controller: KissInvoiceGridController,
    bindings: {
        gridParams: '=', // Critères de recherche de la grille
        data: '<', // Données à afficher dans la grille,
        searchFunction: '&', // Fonction de recherche
        searchPromise: '<'
    }
});
